import React, { useEffect, useCallback, useState } from 'react';
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
import { Collapse, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
// Import Data
import navdata, { buildMenuItems } from "../LayoutMenuData";
import { useNavigate } from "react-router-dom";
//i18n
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { createSelector } from 'reselect';
import { useProfile } from "../../Components/Hooks/UserHooks";
import languages from "../../common/languages";
import { get, map } from "lodash";
import i18n from "../../i18n";

const VerticalLayout = (props) => {
    console.warn("🔥🔥🔥 VERTICAL LAYOUT COMPONENT RENDERING 🔥🔥🔥");
    const history = useNavigate();
    const { userProfile } = useProfile(); // Watch for profile changes
    
    console.warn("🔥 userProfile from hook:", userProfile);
    console.warn("🔥 userProfile?.isAdmin:", userProfile?.isAdmin);
    
    const [navData, setNavData] = useState([]);
    
    // Update navData whenever userProfile changes (including isAdmin status)
    useEffect(() => {
        console.warn("🔥 useEffect triggered, userProfile changed");
        console.warn("🔥 Current userProfile:", userProfile);
        const menuItems = buildMenuItems(userProfile, history);
        console.warn("🔥 buildMenuItems returned, length:", menuItems?.length);
        console.warn("🔥 Menu items array:", menuItems);
        console.warn("🔥 Admin items in menu:", menuItems?.filter(item => item.id === "admin"));
        setNavData(menuItems || []);
        console.warn("🔥 navData state set to:", menuItems?.length, "items");
    }, [userProfile, history]);

    useEffect(() => {
        console.warn("🔥 navData state updated, new length:", navData.length);
        console.warn("🔥 Current navData array:", navData);
    }, [navData]);

    const [openDropdowns, setOpenDropdowns] = useState({});
    
    // Mobile Language Selector state
    const [isMobileLanguageDropdown, setIsMobileLanguageDropdown] = useState(false);
    const [selectedLang, setSelectedLang] = useState("");
    
    useEffect(() => {
        const currentLanguage = localStorage.getItem("I18N_LANGUAGE");
        setSelectedLang(currentLanguage);
    }, []);

    const toggleMobileLanguageDropdown = () => {
        setIsMobileLanguageDropdown(!isMobileLanguageDropdown);
    };

    const changeLanguageAction = lang => {
        i18n.changeLanguage(lang);
        localStorage.setItem("I18N_LANGUAGE", lang);
        setSelectedLang(lang);
    };

    /*
 layout settings
 */
    const selectLayoutState = (state) => state.Layout;
    const selectLayoutProperties = createSelector(
        selectLayoutState,
        (layout) => ({
            layoutType: layout.layoutType,
            leftsidbarSizeType: layout.leftsidbarSizeType,
            sidebarVisibilitytype: layout.sidebarVisibilitytype,
        })
    );

    // Inside your component
    const {
        layoutType,
        leftsidbarSizeType,
        sidebarVisibilitytype
    } = useSelector(selectLayoutProperties);


    //vertical and semibox resize events
    const resizeSidebarMenu = useCallback(() => {
        var windowSize = document.documentElement.clientWidth;
        var hamburgerIcon = document.querySelector(".hamburger-icon");
        if (windowSize >= 1025) {
            if (document.documentElement.getAttribute("data-layout") === "vertical") {
                document.documentElement.setAttribute("data-sidebar-size", leftsidbarSizeType);
            }
            if (document.documentElement.getAttribute("data-layout") === "semibox") {
                document.documentElement.setAttribute("data-sidebar-size", leftsidbarSizeType);
            }
            if ((sidebarVisibilitytype === "show" || layoutType === "vertical" || layoutType === "twocolumn") && document.querySelector(".hamburger-icon")) {
                if (hamburgerIcon !== null) {
                    hamburgerIcon.classList.remove("open");
                }
            } else {
                if (hamburgerIcon !== null) {
                    hamburgerIcon.classList.add("open");
                }
            }

        } else if (windowSize < 1025 && windowSize > 767) {
            document.body.classList.remove("twocolumn-panel");
            if (document.documentElement.getAttribute("data-layout") === "vertical") {
                document.documentElement.setAttribute("data-sidebar-size", "sm");
            }
            if (document.documentElement.getAttribute("data-layout") === "semibox") {
                document.documentElement.setAttribute("data-sidebar-size", "sm");
            }
            if (document.querySelector(".hamburger-icon")) {
                document.querySelector(".hamburger-icon").classList.add("open");
            }
        } else if (windowSize <= 767) {
            document.body.classList.remove("vertical-sidebar-enable");
            if (document.documentElement.getAttribute("data-layout") !== "horizontal") {
                document.documentElement.setAttribute("data-sidebar-size", "lg");
            }
            if (document.querySelector(".hamburger-icon")) {
                document.querySelector(".hamburger-icon").classList.add("open");
            }
        }
    }, [leftsidbarSizeType, sidebarVisibilitytype, layoutType]);

    useEffect(() => {
        window.addEventListener("resize", resizeSidebarMenu, true);
    }, [resizeSidebarMenu]);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        const initMenu = () => {
            const pathName = process.env.PUBLIC_URL + props.router.location.pathname;
            const ul = document.getElementById("navbar-nav");
            const items = ul.getElementsByTagName("a");
            let itemsArray = [...items]; // converts NodeList to Array
            removeActivation(itemsArray);
            let matchingMenuItem = itemsArray.find((x) => {
                return x.pathname === pathName;
            });
            if (matchingMenuItem) {
                activateParentDropdown(matchingMenuItem);
            }
        };
        if (props.layoutType === "vertical") {
            initMenu();
        }
    }, [props.router.location.pathname, props.layoutType]);

    function activateParentDropdown(item) {

        item.classList.add("active");
        let parentCollapseDiv = item.closest(".collapse.menu-dropdown");

        if (parentCollapseDiv) {

            // to set aria expand true remaining
            parentCollapseDiv.classList.add("show");
            parentCollapseDiv.parentElement.children[0].classList.add("active");
            parentCollapseDiv.parentElement.children[0].setAttribute("aria-expanded", "true");
            if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
                parentCollapseDiv.parentElement.closest(".collapse").classList.add("show");
                if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling)
                    parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.classList.add("active");
                if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse")) {
                    parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse").classList.add("show");
                    parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse").previousElementSibling.classList.add("active");
                }
            }
            return false;
        }
        return false;
    }

    const removeActivation = (items) => {
        let actiItems = items.filter((x) => x.classList.contains("active"));

        actiItems.forEach((item) => {
            if (item.classList.contains("menu-link")) {
                if (!item.classList.contains("active")) {
                    item.setAttribute("aria-expanded", false);
                }
                if (item.nextElementSibling) {
                    item.nextElementSibling.classList.remove("show");
                }
            }
            if (item.classList.contains("nav-link")) {
                if (item.nextElementSibling) {
                    item.nextElementSibling.classList.remove("show");
                }
                item.setAttribute("aria-expanded", false);
            }
            item.classList.remove("active");
        });
    };

    const toggleDropdown = (itemId) => {
        setOpenDropdowns(prev => ({
            ...prev,
            [itemId]: !prev[itemId]
        }));
    };

    // Close mobile sidebar
    const closeMobileSidebar = () => {
        // Remove the class that opens the sidebar on mobile
        document.body.classList.remove("vertical-sidebar-enable");
    };

    return (
        <React.Fragment>
            {/* menu Items */}
            {(navData || []).map((item, key) => {
                // Debug: log all items
                console.warn("🔥 Rendering item:", item.id, "label:", item.label, "className:", item.className);
                
                return (
                    <React.Fragment key={key}>
                        {/* Main Header */}
                        {item['isHeader'] ?
                            <li className="menu-title"><span data-key="t-menu">{props.t(item.label)}</span></li>
                            : (
                                (item.subItems ? (
                                    <li className="nav-item">
                                        <Link
                                            onClick={(e) => {
                                                e.preventDefault();
                                                toggleDropdown(item.id);
                                                if (item.click) item.click(e);
                                            }}
                                            className="nav-link menu-link"
                                            to={item.link ? item.link : "/#"}
                                            data-bs-toggle="collapse"
                                        >
                                            <i className={item.icon}></i> <span data-key="t-apps">{props.t(item.label)}</span>
                                        </Link>
                                        <Collapse
                                            className="menu-dropdown"
                                            isOpen={openDropdowns[item.id] || false}
                                            id="sidebarApps">
                                            <ul className="nav nav-sm flex-column test">
                                                {/* subItms  */}
                                                {item.subItems && ((item.subItems || []).map((subItem, key) => (
                                                    <React.Fragment key={key}>
                                                        {!subItem.isChildItem ? (
                                                            <li className="nav-item">
                                                                <Link
                                                                    to={subItem.link ? subItem.link : "/#"}
                                                                    className="nav-link"
                                                                >
                                                                    {props.t(subItem.label)}
                                                                    {subItem.badgeName ?
                                                                        <span className={"badge badge-pill bg-" + subItem.badgeColor} data-key="t-new">{subItem.badgeName}</span>
                                                                        : null}
                                                                </Link>
                                                            </li>
                                                        ) : (
                                                            <li className="nav-item">
                                                                <Link
                                                                    onClick={subItem.click}
                                                                    className="nav-link"
                                                                    to="/#"
                                                                    data-bs-toggle="collapse"
                                                                > {props.t(subItem.label)}
                                                                </Link>
                                                                <Collapse className="menu-dropdown" isOpen={subItem.stateVariables} id="sidebarEcommerce">
                                                                    <ul className="nav nav-sm flex-column">
                                                                        {/* child subItms  */}
                                                                        {subItem.childItems && (
                                                                            (subItem.childItems || []).map((childItem, key) => (
                                                                                <React.Fragment key={key}>
                                                                                    {!childItem.childItems ?
                                                                                        <li className="nav-item">
                                                                                            <Link
                                                                                                to={childItem.link ? childItem.link : "/#"}
                                                                                                className="nav-link">
                                                                                                {props.t(childItem.label)}
                                                                                            </Link>
                                                                                        </li>
                                                                                        : <li className="nav-item">
                                                                                            <Link to="/#" className="nav-link" onClick={childItem.click} data-bs-toggle="collapse">
                                                                                                {props.t(childItem.label)}
                                                                                            </Link>
                                                                                            <Collapse className="menu-dropdown" isOpen={childItem.stateVariables} id="sidebaremailTemplates">
                                                                                                <ul className="nav nav-sm flex-column">
                                                                                                    {childItem.childItems.map((subChildItem, key) => (
                                                                                                        <li className="nav-item" key={key}>
                                                                                                            <Link to={subChildItem.link} className="nav-link" data-key="t-basic-action">{props.t(subChildItem.label)} </Link>
                                                                                                        </li>
                                                                                                    ))}
                                                                                                </ul>
                                                                                            </Collapse>
                                                                                        </li>
                                                                                    }
                                                                                </React.Fragment>
                                                                            ))
                                                                        )}
                                                                    </ul>
                                                                </Collapse>
                                                            </li>
                                                        )}
                                                    </React.Fragment>
                                                ))
                                                )}
                                            </ul>

                                        </Collapse>
                                    </li>
                                ) : (
                                    // Handle mobile items (language, profile, logout)
                                    item.id === "mobile-language" ? (
                                        <li className={`nav-item ${item.className ? item.className : ""}`}>
                                            <Dropdown isOpen={isMobileLanguageDropdown} toggle={toggleMobileLanguageDropdown} className="w-100">
                                                <DropdownToggle tag="button" type="button" className="btn btn-link nav-link menu-link w-100 text-start" style={{ textDecoration: 'none' }}>
                                                    <i className={item.icon}></i> <span>{props.t(item.label)}</span>
                                                </DropdownToggle>
                                                <DropdownMenu className="notify-item language py-2">
                                                    {map(Object.keys(languages), key => (
                                                        <DropdownItem
                                                            key={key}
                                                            onClick={() => {
                                                                changeLanguageAction(key);
                                                                setIsMobileLanguageDropdown(false);
                                                            }}
                                                            className={`notify-item ${selectedLang === key ? "active" : "none"}`}
                                                        >
                                                            <img
                                                                src={get(languages, `${key}.flag`)}
                                                                alt="Language"
                                                                className="me-2 rounded"
                                                                height="18"
                                                            />
                                                            <span className="align-middle">
                                                                {get(languages, `${key}.label`)}
                                                            </span>
                                                        </DropdownItem>
                                                    ))}
                                                </DropdownMenu>
                                            </Dropdown>
                                        </li>
                                    ) : (
                                        <li className={`nav-item ${item.className ? item.className : ""}`}>
                                            <Link
                                                onClick={() => { if(item.click) item.click(); closeMobileSidebar(); }}
                                                className="nav-link menu-link"
                                                to={item.link ? item.link : "/#"}>
                                                <i className={item.icon} style={{ marginRight: '6px' }}></i> <span>{props.t(item.label)}</span>
                                            </Link>
                                        </li>
                                    )
                                ))
                            )
                        }
                    </React.Fragment>
                );
            })}
        </React.Fragment>
    );
};

VerticalLayout.propTypes = {
    location: PropTypes.object,
    t: PropTypes.any,
};

export default withRouter(withTranslation()(VerticalLayout));
